import { Step } from '@main/mobile-menu/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { MobileMenuData, MobileMenuState, StateWithMobileMenu } from '../mobile-menu-state';
import { getMainFeatureState } from './feature.selector';

export const getMobileMenuState: MemoizedSelector<StateWithMobileMenu, MobileMenuData> = createSelector(
  getMainFeatureState,
  (state: MobileMenuState) => state.mobileMenu,
);

export const getMobileMenuHistory: MemoizedSelector<StateWithMobileMenu, Step[] | null> = createSelector(
  getMobileMenuState,
  (data: MobileMenuData) => data.steps || null,
);

export const getMobileMenuDepth: MemoizedSelector<StateWithMobileMenu, number | null> = createSelector(
  getMobileMenuState,
  (data: MobileMenuData) => data.depth || null,
);
export const getMobileMenuCurrentStep: MemoizedSelector<StateWithMobileMenu, Step | null> = createSelector(
  getMobileMenuState,
  (data: MobileMenuData) => data.steps[data.depth - 1] || null,
);

export const getMobileMenuPrevStep: MemoizedSelector<StateWithMobileMenu, Step | null> = createSelector(
  getMobileMenuState,
  (data: MobileMenuData) => data.steps[data.depth - 2] || null,
);
